import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import DefaultDashboard from "../../pages/Dashboard/Default";
import WorkspaceDashboard from "../WorkspaceDashboard";

const SiteDashboard = ({ selectedWorkspace }) => {

  const location = useLocation();

  const renderSiteDashboard = () => {
    switch (selectedWorkspace.id) {
      case 18:  // Matilda
      case 176: // KLARA
      case 177: // BEATA
      case 206: // SIV
        return (
          <WorkspaceDashboard
            route={location.pathname}
            siteId={selectedWorkspace.id}
          />
        );
      default:
        return (
          <DefaultDashboard workspace={selectedWorkspace.name} />
        );
    }
  };

  return (
    <Box sx={{ position: "relative" }}>
      {renderSiteDashboard()}
    </Box>
  );

};

SiteDashboard.propTypes = {
  selectedWorkspace: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
};

export default SiteDashboard;
